// Esto es para la autenticacion de forma globaaaal
import React, { createContext, useContext, useEffect, useState } from 'react';
import { recuperarMisCotizaciones } from '../services/misCotizacionesService';
import { fetchCurrentUser, logout as authLogout, User } from '../services/authService';

interface AuthContextType {
    user: User | null;
    isAuthenticated: boolean;
    loading: boolean;
    setUser: React.Dispatch<React.SetStateAction<User | null>>;
    setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
    logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const userData = await fetchCurrentUser();
                setUser(userData);
                setIsAuthenticated(true);
            } catch (error) {
                setUser(null);
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };
    
        checkAuth();
    }, []);

    useEffect(() => {
        if (isAuthenticated && user) {
            recuperarMisCotizaciones().catch(() => { /* Retry when opening Mis cotizaciones. */ });
        }
    }, [isAuthenticated, user?.id]);

    const logout = async () => {
        await authLogout();
        setUser(null);
        setIsAuthenticated(false);
        window.location.href = '/login';
    };

    return (
        <AuthContext.Provider value={{ user, isAuthenticated, loading, setUser, setIsAuthenticated, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

